//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ShipDesign.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["parameterName","parameterValue"],"EditParameter",{},2,0],[["parameterName","parameterStatus","isAdd"],"SetParameterStatus",{},3,0],[["parameterName","parameterStatus","isAdd"],"SetPaintParameterStatus",{},3,0],[["parameterName","parameterValue"],"EditPrimaryParameter",{},2,0],[["numCheckedPara"],"GetCheckedParameters",{R_:{checkedPara:"ShipDesign.PaintParametersParameterValue[]"}},0,0],[[],"RefreshParentParameter",{},0,0],[[],"ClearCatogoryToKruDataPtrMap",{},0,0]],[]];
SPLM.ShipDesign.PaintParametersData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ShipDesign.PaintParametersData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ShipDesign.PaintParametersData.JaShipPaintParametersStatus = Object.freeze({
    "Selected" : "Selected"});

export default SPLM;